/* ============================================================
   CULT RACING — DROP PAGE
   Lots are server-rendered by Liquid from the drop's collection;
   this wires the reveal, the sticky drop bar, the REAL Shopify
   cart (/cart/add.js, /cart.js, /cart/change.js) and the notify
   line.

   The cart is a straight carry-over of the homepage's optimistic
   drawer. It is deliberate, measured work: do not "simplify" it
   back to awaiting the network before opening. See
   SHOPIFY-HANDOFF.md section 9.
   ============================================================ */
(function () {
  "use strict";

  var money = function (cents) { return "$" + (cents / 100).toFixed(2); };
  /* The cart drawer is built with innerHTML, and since the personalized drop
     it renders a string the VISITOR typed. Escape everything that is not ours. */
  var esc = function (s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  };
  var els = {
    count: document.getElementById("cartCount"),
    headCount: document.getElementById("cartHeadCount"),
    body: document.getElementById("cartBody"),
    subtotal: document.getElementById("cartSubtotal"),
    checkout: document.getElementById("checkoutBtn"),
    drawer: document.getElementById("cart"),
    overlay: document.getElementById("cartOverlay"),
    toast: document.getElementById("toast")
  };

  /* ---------- SHOPIFY CART (real, drawn optimistically) ---------- */
  var cartState = { item_count: 0, total_price: 0, items: [] };
  var inFlight = Object.create(null);
  var busy = function () { for (var k in inFlight) return true; return false; };

  function recount() {
    cartState.item_count = cartState.items.reduce(function (a, l) { return a + l.quantity; }, 0);
    cartState.total_price = cartState.items.reduce(function (a, l) { return a + l.final_line_price; }, 0);
  }
  function applyCart(cart) { cartState = cart; render(cartState); }
  function applyCartIfIdle(cart) { if (!busy()) applyCart(cart); }

  /* ---------- PERSONALIZATION (inert unless a lot renders the input) ----------
     A personalized lot carries ONE [data-personalize-input] inside .lot. Its
     value rides along as a Shopify LINE ITEM PROPERTY, which is native: it
     reaches the cart, the real checkout, the order and the packing slip with
     no app and no extra scope. Proven on the live store 2026-08-19.

     Two things this changes for personalized lots only:
     - the same size ordered with two different tags must stay TWO lines, so
       the in-flight guard and the optimistic-row match are keyed by
       variant + value, not variant alone. Keying by variant alone would
       merge a second tag into the first tag's row and print it twice.
     - an empty or malformed tag must not reach the cart. The gate is NATIVE
       constraint validation (required + pattern in Liquid), so it holds even
       if cr-personalize.js never loads.

     A lot with no such input produces props = null and lineKey = variantId,
     which is byte-for-byte the old behaviour. Black Sheep and Antisocial
     render no personalize input, so nothing on those pages changes. */
  function readPersonalization(lot) {
    var input = lot && lot.querySelector("[data-personalize-input]");
    if (!input) return null;
    var name = input.getAttribute("data-personalize-name") || "Tag";
    var value = (input.value || "").trim();
    return { input: input, name: name, value: value, ok: !!value && input.checkValidity() };
  }

  function rejectPersonalization(pz, lot) {
    var field = lot && lot.querySelector("[data-personalize]");
    if (field) {
      field.setAttribute("data-personalize-error", "true");
      // let the class land in its own frame so the shake replays on a repeat tap
      void field.offsetWidth;
    }
    pz.input.focus();
    showToast(pz.value ? "Letters and numbers only" : "Add your tag first");
  }

  function addToCart(variantId, label, btn) {
    var lot = btn && btn.closest(".lot");

    var pz = readPersonalization(lot);
    if (pz && !pz.ok) { rejectPersonalization(pz, lot); return; }
    var props = pz ? (function () { var o = {}; o[pz.name] = pz.value; return o; })() : null;
    var lineKey = pz ? variantId + "|" + pz.value : String(variantId);

    if (inFlight[lineKey]) return; // a second tap mid-request would silently add a 2nd unit
    inFlight[lineKey] = true;
    if (btn) btn.classList.add("is-adding");

    var frontImg = lot && lot.querySelector("img.front");
    var priceCents = btn ? parseInt(btn.dataset.price, 10) : 0;
    if (isNaN(priceCents)) priceCents = 0;
    var solo = btn && btn.classList.contains("size-btn--solo");

    /* Same variant, different tag = two DIFFERENT lines, and Shopify agrees:
       it returns a distinct line key per property set (verified on the live
       store). Matching on the variant alone would fold a second tag into the
       first tag's row, so the drawer would show one line of quantity 2 and the
       buyer would believe they had ordered two of the same tag. With props
       null this collapses to the old variant-only comparison exactly. */
    function sameLine(l) {
      if (String(l.id) !== String(variantId)) return false;
      if (!props) return true;
      var k = pz.name;
      return ((l.properties && l.properties[k]) || "") === (props[k] || "");
    }

    var existing = null, i;
    for (i = 0; i < cartState.items.length; i++) {
      if (sameLine(cartState.items[i])) { existing = cartState.items[i]; break; }
    }
    if (existing) {
      existing.quantity += 1;
      existing.final_line_price += priceCents;
    } else {
      cartState.items.push({
        id: variantId, key: null, pending: true,
        product_title: label || "Item",
        variant_title: solo ? "" : (btn ? btn.textContent.trim() : ""),
        quantity: 1,
        final_line_price: priceCents,
        properties: props,
        image: frontImg ? frontImg.src : ""
      });
    }
    recount(); render(cartState);
    openCart(); showToast((label || "Item") + " added"); bumpCount();

    function settled() { delete inFlight[lineKey]; if (btn) btn.classList.remove("is-adding"); }

    fetch("/cart/add.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [props ? { id: variantId, quantity: 1, properties: props }
                                          : { id: variantId, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function (res) {
        // swap only THIS line's placeholder for the server's line; clearing
        // every pending row would erase a second add still in flight
        var added = (res && res.items) || [];
        cartState.items = cartState.items.filter(function (l) {
          return !(l.pending && sameLine(l));
        });
        added.forEach(function (line) {
          var idx = -1;
          for (var j = 0; j < cartState.items.length; j++) {
            if (cartState.items[j].key === line.key) { idx = j; break; }
          }
          if (idx > -1) cartState.items[idx] = line; else cartState.items.push(line);
        });
        recount(); render(cartState);
        settled();
        refresh();
      })
      .catch(function () {
        for (var m = 0; m < cartState.items.length; m++) {
          if (!sameLine(cartState.items[m])) continue;
          var line = cartState.items[m];
          if (line.pending || line.quantity <= 1) cartState.items.splice(m, 1);
          else { line.quantity -= 1; line.final_line_price -= priceCents; }
          break;
        }
        recount(); render(cartState);
        showToast("Couldn't add. Try again.");
        settled();
        refresh();
      });
  }
  function removeItem(key) {
    fetch("/cart/change.js", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(applyCart).then(bumpCount);
  }
  function refresh() { return fetch("/cart.js").then(function (r) { return r.json(); }).then(applyCartIfIdle); }

  function render(cart) {
    var q = cart.item_count;
    els.count.textContent = q;
    els.count.dataset.empty = q === 0 ? "true" : "false";
    els.headCount.textContent = q ? "(" + q + ")" : "";
    els.subtotal.textContent = money(cart.total_price);
    var pending = cart.items.some(function (l) { return l.pending; });
    els.checkout.disabled = q === 0 || pending;
    if (!cart.items.length) {
      els.body.innerHTML =
        '<div class="cart__empty"><svg viewBox="0 0 24 24" width="46" height="46">' +
        '<path d="M6 7h12l-1 13H7L6 7Z" fill="none" stroke="currentColor" stroke-width="1.3"/>' +
        '<path d="M9 7a3 3 0 0 1 6 0" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>' +
        "<p>Your bag is empty.<br>Nothing claimed yet.</p></div>";
      return;
    }
    els.body.innerHTML = cart.items.map(function (l) {
      var opt0 = l.options_with_values && l.options_with_values[0] ? l.options_with_values[0].name : "";
      var sub = l.variant_title && l.variant_title !== "Default Title" ? (/^colou?r$/i.test(opt0) ? "Color " : "Size ") + l.variant_title : "One size";
      /* A personalized line has to SHOW its tag in the bag. Someone ordering a
         hoodie and a tee with two different tags cannot otherwise tell which
         is which, and the tag is the whole product.

         🔴 ESCAPED, because this is the one string on the page that a visitor
         typed and it is going through innerHTML. The field only permits
         [A-Za-z0-9], but this also renders whatever /cart.js hands back, which
         is a different trust boundary: a property set from another page, an
         app, or a hand-built permalink is not covered by our pattern. */
      var props = l.properties || {};
      var extra = "";
      for (var pk in props) {
        if (!Object.prototype.hasOwnProperty.call(props, pk)) continue;
        if (pk.charAt(0) === "_" || !props[pk]) continue; // _-prefixed are Shopify's hidden convention
        extra += '<p class="cart-item__prop">' + esc(pk) + ": <b>" + esc(props[pk]) + "</b></p>";
      }
      return '<div class="cart-item">' +
        '<img class="cart-item__thumb" src="' + (l.image || "") + '" alt="">' +
        '<div class="cart-item__info"><h4>' + esc(l.product_title) + "</h4><p>" + sub +
        (l.quantity > 1 ? " · x" + l.quantity : "") + "</p>" + extra + "</div>" +
        '<div class="cart-item__right"><span class="cart-item__price">' + money(l.final_line_price) + "</span>" +
        (l.key
          ? '<button class="cart-item__remove" data-remove="' + l.key + '">Remove</button>'
          : '<span class="cart-item__remove is-pending">Adding</span>') +
      "</div></div>";
    }).join("");
    els.body.querySelectorAll("[data-remove]").forEach(function (b) {
      b.addEventListener("click", function () { removeItem(b.dataset.remove); });
    });
  }

  document.querySelectorAll(".size-btn").forEach(function (btn) {
    if (btn.disabled) return;
    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      addToCart(btn.dataset.variantId, btn.dataset.title, btn);
    });
  });

  function bumpCount() { els.count.classList.remove("bump"); void els.count.offsetWidth; els.count.classList.add("bump"); }
  var toastTimer;
  function showToast(msg) {
    els.toast.textContent = msg; els.toast.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { els.toast.classList.remove("show"); }, 2200);
  }

  function openCart() {
    els.overlay.hidden = false;
    requestAnimationFrame(function () { els.overlay.classList.add("show"); });
    els.drawer.classList.add("open"); els.drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("cart-open");
  }
  function closeCart() {
    els.overlay.classList.remove("show"); els.drawer.classList.remove("open");
    els.drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("cart-open");
    setTimeout(function () { els.overlay.hidden = true; }, 350);
  }
  document.getElementById("cartToggle").addEventListener("click", openCart);
  document.getElementById("cartClose").addEventListener("click", closeCart);
  els.overlay.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });
  els.checkout.addEventListener("click", function () { window.location.href = "/checkout"; });

  refresh(); // sync with any cart the visitor already has

  /* ---------- DROP BAR: rides in once the poster is behind you ---------- */
  (function initBar() {
    var bar = document.getElementById("dbar");
    var plate = document.getElementById("plate");
    if (!bar || !plate) return;
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle("show", !en.isIntersecting); });
      }, { rootMargin: "-70% 0px 0px 0px", threshold: 0 }).observe(plate);
    } else {
      bar.classList.add("show");
    }
  })();

  /* ---------- jump chips: mark the strip when it has more to reach ----------
     A drop with accessories can produce six or more garment groups, which
     overflows the bar on a phone. The strip scrolls; this only drives the
     right-edge fade so it is discoverable. */
  (function initJumpStrip() {
    var strip = document.querySelector(".dbar__jump");
    if (!strip) return;
    function measure() {
      var over = strip.scrollWidth - strip.clientWidth;
      strip.classList.toggle("is-scrollable", over > 4);
      strip.classList.toggle("at-end", over > 4 && strip.scrollLeft >= over - 4);
    }
    strip.addEventListener("scroll", measure, { passive: true });
    window.addEventListener("resize", measure);
    measure();
  })();

  /* ---------- back images: fetched a screen ahead, not all at once ----------
     A 40-piece drop carries 80 product images. The back print is invisible
     until the lot is hovered or centred, so it is held in data-src and
     promoted well before it is needed rather than on first paint. */
  (function initBackImages() {
    var backs = [].slice.call(document.querySelectorAll(".lot img.back[data-src]"));
    if (!backs.length) return;
    function load(img) {
      // srcset first: setting src alone would let the browser commit to the
      // fallback before the candidate list exists
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; delete img.dataset.srcset; }
      if (img.dataset.src) { img.src = img.dataset.src; delete img.dataset.src; }
    }
    if (!("IntersectionObserver" in window)) { backs.forEach(load); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        load(en.target); obs.unobserve(en.target);
      });
    }, { rootMargin: "900px 0px 900px 0px" });
    backs.forEach(function (img) { obs.observe(img); });
  })();

  /* ---------- MOBILE: reveal the lot centred in the viewport ----------
     95% of this audience is on a phone, where there is no hover, so the
     back image and sizes have to come to them. */
  (function initAutoReveal() {
    var noHover = window.matchMedia("(hover:none)").matches ||
                  window.matchMedia("(pointer:coarse)").matches ||
                  (navigator.maxTouchPoints || 0) > 0;
    if (!noHover || !("IntersectionObserver" in window)) return;

    /* 1.5s DWELL BEFORE THE FRONT -> BACK FLIP (Mudit, 2026-09-03). Scrolling
       used to snap every lot to its back print the instant it crossed the centre
       band, so a fast scroll strobed through the whole rack and you never saw a
       front. The lot now has to hold the centre for DWELL_MS before it turns.

       🔴 TWO CLASSES, NOT ONE, AND THE SPLIT IS THE POINT. `is-active` still
       lands IMMEDIATELY, because it also raises the buy panel and the size
       keypad: delaying that would make a shopper wait a second and a half to tap
       a size, which is a conversion change nobody asked for. Only `is-flipped`
       waits, and only the two image rules key off it.

       Additive on purpose. A drop stylesheet that never mentions `is-flipped`
       keeps flipping on `is-active` exactly as before, so the older drop pages
       that share this file are untouched. */
    var DWELL_MS = 1500;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var lot = en.target;
        if (lot._flipTimer) { clearTimeout(lot._flipTimer); lot._flipTimer = null; }
        if (en.isIntersecting) {
          lot.classList.add("is-active");
          lot._flipTimer = setTimeout(function () {
            lot._flipTimer = null;
            lot.classList.add("is-flipped");
          }, DWELL_MS);
        } else {
          /* leaving reverts at once: a lot scrolled past should not sit on its
             back print, and a half-served timer must not fire behind you */
          lot.classList.remove("is-active");
          lot.classList.remove("is-flipped");
        }
      });
    }, { rootMargin: "-42% 0px -42% 0px", threshold: 0 });
    document.querySelectorAll(".lot").forEach(function (l) { obs.observe(l); });
  })();

  /* ---------- reveal on scroll ---------- */
  if ("IntersectionObserver" in window) {
    var revObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); revObs.unobserve(en.target); } });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".reveal").forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) el.classList.add("in"); else revObs.observe(el);
    });
  } else { document.querySelectorAll(".reveal").forEach(function (el) { el.classList.add("in"); }); }

  /* ---------- NOTIFY -> Omnisend (same Cloudflare proxy as the homepage) ---------- */
  (function initNotify() {
    var form = document.getElementById("notifyForm");
    if (!form) return;
    var note = document.getElementById("notifyNote");
    var done = document.getElementById("notifyDone");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.name.value.trim() || !form.email.value.trim()) { form.reportValidity(); return; }
      var btn = form.querySelector("button[type=submit]");
      btn.disabled = true; if (note) note.textContent = "Signing you up...";
      var consentEl = document.getElementById("notifyConsent");
      fetch("https://cult-racing.pages.dev/api/join", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name.value.trim(),
          phone: form.phone.value.trim(),
          email: form.email.value.trim(),
          // the proxy only subscribes the phone to SMS when this is true, so a
          // phone collected without it is a phone thrown away
          consent: !!(consentEl && consentEl.checked),
          company: form.company.value, // honeypot
          source: "drop-page"
        })
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          if (d && d.ok) { form.hidden = true; if (done) done.hidden = false; }
          else { if (note) note.textContent = "Something went wrong. Try again."; btn.disabled = false; }
        })
        .catch(function () { if (note) note.textContent = "Something went wrong. Try again."; btn.disabled = false; });
    });
  })();
})();
